// extracted by mini-css-extract-plugin
export default {"subCategoryImage":"subCategoryContainer_subCategoryImage__EAp1h","subCategoryContainer":"subCategoryContainer_subCategoryContainer__LPlh4"};